import { clientFetch } from '~/api/clientFetch';

export async function sendReminder(signOut: () => void, id: string): Promise<void> {
  await clientFetch(`/users/${id}/login_reminders`, { method: 'POST' }, signOut);
}
